import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { limitsApi } from "@/api/limits";
import { MyLimitsData } from "@/types/LimitsTypes";

interface LimitsState {
  limits: MyLimitsData | null;
  isLoaded: boolean;
  fetchLimits: () => Promise<void>;
  clearLimits: () => void;
}

export const useLimitsStore = create<LimitsState>()(
  devtools(
    (set) => ({
      limits: null,
      isLoaded: false,

      fetchLimits: async () => {
        try {
          const response = await limitsApi.getMyLimits();
          if (response.success && response.data) {
            set({ limits: response.data, isLoaded: true });
          }
        } catch {
          set({ isLoaded: true });
        }
      },

      clearLimits: () => set({ limits: null, isLoaded: false }),
    }),
    { name: "LimitsStore" },
  ),
);
